import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const ZaloTaskZNSRoutes = ({ ZaloTask, Edit }: { ZaloTask: React.ComponentType; Edit: React.ComponentType }) => (
  <Routes>
    <Route path={''} element={<ZaloTask />} />
    <Route path={ROUTES.ZALO_ZNS.ZALO_TASK_ZNS.EDIT} element={<Edit />} />
  </Routes>
);
